<template>
    <v-flex>
      <v-flex v-if="loadAction.failed"
              class="admin-only-text">
        <div class="admin-only-text__wrapper" >
          <div class="admin-only-text__title">{{chapterWaiverConstants.ADMIN_ONLY_TITLE}}</div>
          <div class="admin-only-text__details">{{chapterWaiverConstants.ADMIN_ONLY_TEXT}}</div>
        </div>
      </v-flex>
      <v-flex v-else-if="!loadAction.failed && checkedWaiverVisibility">
        <ChapterWaiverBanner></ChapterWaiverBanner>
        <v-container>
          <v-flex
              md10
              lg9
              mx-auto
              my-5
              class="waiver-block">
            <v-card class="panelBlock">
              <v-layout
                  row
                  wrap
                  class="prospective-member-header">
                <v-flex
                    xs12
                    sm6
                    lg8>
                  <v-flex tag="h2">{{chapterWaiverConstants.PROSPECTIVE_MEMBER_WAIVERS}}</v-flex>
                </v-flex>
                <v-flex
                    xs12
                    sm6
                    lg4
                    class="prospective-member-header__prospect"
                    v-if="isWaiverList">
                  <v-text-field
                      prepend-inner-icon="search"
                      single-line
                      label="Search for a prospect"
                      data-qe-id="chapterofficer_waiverSearch"
                      clearable
                      solo
                      flat
                      hide-details
                      v-model="waiverSearchText"
                      @keyup="searchWaiverDialog"
                      @click:clear="clearSearchText()"
                      class="search_bar">
                  </v-text-field>
                  <v-flex class="result inner-scrollbar">
                    <v-flex v-if="waiverSearchInProgress && hideSearchResults" class="result__spinner">
                      <status-overlay :action="{pending: waiverSearchInProgress}"></status-overlay>
                    </v-flex>
                    <v-flex v-if="!waiverSearchInProgress && hideSearchResults">
                      <v-list
                          two-line
                          v-for="(lead, i) in searchWaiverResult"
                          :key="i">
                        <v-list-tile @click="selectWaiver(lead.id)">
                          <v-list-tile-avatar>
                            <img :src="lead.profileImageUrl" :onerror="imageErrorFallback(lead)">
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{lead.firstName}} {{lead.lastName}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-list
                        class="result__see-all"
                        one-line
                        v-if="chunkedSearchResults && !waiverSearchInProgress && hideSearchResults">
                      <v-list-tile data-qe-id="chapter_officer_search_seemore" @click="seeMore()">
                        <v-list-tile-content>
                          <v-list-tile-title>{{chapterWaiverConstants.SEEALL}}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-flex>
                <v-flex
                    v-if="!isWaiverList"
                    data-qe-id="chapter_Waivers_showAll_link"
                    class="chapter-waivers__show-all-link"><span class="ypo_blue_color" @click="ShowAllWaiver()">{{chapterWaiverConstants.VIEW_ALL_WAIVERS}}</span></v-flex>
              </v-layout>
              <div v-infinite-scroll="listWaiversForCommunity" :infinite-scroll-distance="2000">
                <v-flex v-if="!isSearchResult">
                  <v-flex v-if="listOfWaivers && listOfWaivers.length>0">
                    <v-flex
                        class="prospective-member"
                        v-for="(prospect,i) in listOfWaivers"
                        :key="i">
                      <WaiverForm :prospect="prospect" :sequence="i" />
                    </v-flex>
                  </v-flex>
                  <v-flex class="prospective-member" v-if="waiverDetails && listOfWaivers && !(listOfWaivers.length>0)">
                    <WaiverForm :prospect="waiverDetails" :sequence="1" />
                  </v-flex>
                  <v-flex
                      class="prospective-member__loading"
                      v-if="loadAction.pending"
                      justify-center
                      text-xs-center>
                    <v-progress-circular indeterminate color="grey"></v-progress-circular>
                  </v-flex>
                  <v-flex
                      class="prospective-member__loading"
                      v-else-if="loadAction.failed"
                      justify-center
                      text-xs-center>
                    {{chapterWaiverConstants.ERROR_LOADING}}
                  </v-flex>
                  <v-flex
                      class="prospective-member__loading"
                      v-else-if="!loadAction.pending && listOfWaivers && !(listOfWaivers.length > 0) || (!waiverDetails && !loadDetails.pending && waiverSearchText && waiverSearchText.length > 2)"
                      justify-center
                      text-xs-center>
                    {{chapterWaiverConstants.WAIVER_LIST_EMPTY}}
                  </v-flex>
                </v-flex>
              </div>
              <div v-if="isSearchResult">
                <v-flex
                    class="prospective-member__loading"
                    v-if="isSelectedLoad"
                    justify-center
                    text-xs-center>
                  <v-progress-circular indeterminate color="grey"></v-progress-circular>
                </v-flex>
                <v-flex class="prospective-member" v-if="!isSelectedLoad">
                  <WaiverForm :prospect="waiverDetails" :sequence="1" />
                </v-flex>
              </div>
            </v-card>
          </v-flex>
        </v-container>
      </v-flex>
    </v-flex>
</template>

<script>
    import ChapterWaiverBanner from "./ChapterWaiverBanner";
    import WaiverForm from "./WaiverForm";
    import { chapterWaiverConstants } from "./ChapterWaiver.constants";
    import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import { headerConstant } from "../Header/header.constant";

    export default {
        name: "ChapterWaiver",
        components: {
            ChapterWaiverBanner,
            WaiverForm,
            StatusOverlay,
        },
        created() {
            //To-Do: move these API calls to calling page once it is ready.
            this.resetChapterWaiverList();
            this.determineWaiversView();
            this.getWaiverQuestions();
            this.getCompanyTypes();
            this.getCorporationTypes();
            this.getWaiverTypes();
            this.getTitleTypes();
        },
        data: () => {
            return {
                chapterWaiverConstants,
                getListWaiverInProgress: false,
                getWaiverDetailInProgress: false,
                waiverSearchText: '',
                waiverSearchInProgress: false,
                hideSearchResults: false,
                isSearchResult: false,
                isSelectedLoad: false,
                headerConstant,
                waiverId: headerConstant.EMPTY_GUID,
                checkedWaiverVisibility: false,
            };
        },
        methods: {
            ...mapActions({
                getListOfWaivers: `chapterWaiver/${storeAction.getListOfWaivers}`,
                getWaiverQuestions: `chapterWaiver/${storeAction.getWaiverQuestions}`,
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
                getCompanyTypes: `chapterWaiver/${storeAction.getCompanyTypes}`,
                searchWaiverRequests: `chapterWaiver/${storeAction.searchWaiverRequests}`,
                getCorporationTypes: `chapterWaiver/${storeAction.getCorporationTypes}`,
                getWaiverTypes: `chapterWaiver/${storeAction.getWaiverTypes}`,
                getTitleTypes: `chapterWaiver/${storeAction.getTitleTypes}`,
            }),
            ...mapMutations({
                resetChapterWaiverList: `chapterWaiver/${storeMutation.resetChapterWaiverList}`,
                pushSearchResults: `chapterWaiver/${storeMutation.pushSearchResults}`,
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                setSearchResults: `chapterWaiver/${storeMutation.setSearchResults}`,
            }),
            determineWaiversView() {
              this.listWaiversForCommunity();
            },
            listWaiversForCommunity() {
                if (!this.disableWaiverListInfiniteScroll && !this.getListWaiverInProgress && !this.isSearchResult) {
                    this.getListWaiverInProgress = true;
                    const viewType = this.chapterWaiverConstants.CHAPTEROFFICER;
                    let req = {};
                    if (this.$route && this.$route.query && this.$route.query.leadId) {
                        this.waiverId = this.$route.query.leadId;
                    }
                    req = {
                        viewType,
                        leadId: this.waiverId || this.headerConstant.EMPTY_GUID,
                    };
                    if (this.communityIdFromRoute) {
                       req.communityId = this.communityIdFromRoute;
                     }
                    this.getListOfWaivers(req)
                        .finally(() => {
                            this.getListWaiverInProgress = false;
                            this.checkedWaiverVisibility = true;
                        });
                }
            },
            searchWaiverDialog() {
                this.setVisibleProspect(null);
                if (this.waiverSearchText === '' || (this.waiverSearchText && this.waiverSearchText.length <= 2)) {
                    this.hideSearchResults = false;
                    this.isSearchResult = false;
                    return false;
                }
                this.hideSearchResults = true;
                this.waiverSearchInProgress = true;
                const req = {
                    viewType: this.chapterWaiverConstants.CHAPTEROFFICER,
                    communityId: this.$route.params.communityId,
                    searchToken: this.waiverSearchText,
                };
                this.searchWaiverRequests(req).then(() => {
                    this.waiverSearchInProgress = false;
                });
            },
            clearSearchText() {
                this.setSearchResults(null);
                this.hideSearchResults = false;
                this.isSearchResult = false;
                this.setVisibleProspect(null);
            },
            imageErrorFallback(element) {
                element.profileImageUrl = element.fallbackProfileImageUrl;
                return `this.src='${element.fallbackProfileImageUrl || ''}';this.onerror=null;`;
            },
            selectWaiver(id) {
                this.getListWaiverInProgress = true;
                this.isSelectedLoad = true;
                const req = {
                    viewType: this.chapterWaiverConstants.CHAPTEROFFICER,
                    leadId: id,
                    isSearchView: true,
                };
                if (this.communityIdFromRoute) {
                  req.communityId = this.communityIdFromRoute;
                }
                this.getWaiverDetails(req)
                    .then(() => {
                        this.isSelectedLoad = false;
                        this.getListWaiverInProgress = false;
                        this.hideSearchResults = false;
                        this.isSearchResult = true;
                    });
            },
            seeMore() {
                this.pushSearchResults();
            },
            ShowAllWaiver() {
                this.resetChapterWaiverList();
                this.waiverId = this.headerConstant.EMPTY_GUID;
                this.$router.push({
                    path: `/chapterWaiver/${this.$route.params.communityId}`,
                });
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                listOfWaivers: `chapterWaiver/${storeGetters.listOfWaivers}`,
                waiverDetails: `chapterWaiver/${storeGetters.waiverDetails}`,
                disableWaiverListInfiniteScroll: `chapterWaiver/${storeGetters.disableWaiverListInfiniteScroll}`,
                searchWaiverResult: `chapterWaiver/${storeGetters.searchResults}`,
                chunkedSearchResults: `chapterWaiver/${storeGetters.chunkedSearchResults}`,
            }),
            loadAction() {
                return this.actions[storeAction.getListOfWaivers];
            },
            loadDetails() {
                return this.actions[storeAction.getWaiverDetails];
            },
            isWaiverList() {
                return this.waiverId === this.headerConstant.EMPTY_GUID;
            },
            communityIdFromRoute() {
              return this.$route.params.communityId;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .chapter-waivers {
        &__show-all-link {
            padding: 14px 10px 0 10px;
            position: absolute;
            right: 10px;
            top: 10px;

            span {
                text-decoration: underline;
                font-weight: 600;
                cursor: pointer;
            }

            @include breakpoint(xs) {
                position: relative;
                text-align: center;
            }

        }
    }

    .admin-only-text {
      display: flex;
      justify-content: center;
      text-align: center;
      &__wrapper {
        margin-top: 10%;
        max-width: 350px;
      }
      &__title {
        color: $ypo-primary-blue;
        font-size: 18px;
      }
    }

    .prospective-member-header {
        padding: 10px 10px 10px 0;
        border-bottom: 1px solid $ypo-tile-border;

        h2 {
            border-bottom: 0 !important;
        }

        .search_bar {
            .v-input__slot {
                border-bottom: 1px solid $ypo-tile-border;
                padding-left: 0 !important;

                .v-icon {
                    color: rgba($ypo-blue, 0.5);
                    font-size: 26px;
                }

                .v-label {
                    font-style: italic;
                }
            }
        }

        &__prospect {
            position: relative;

            .result {
                border: 1px solid $ypo-tile-border;
                position: absolute;
                width: 100%;
                background-color: $white;
                z-index: 1;
                border-radius: 3px 0 0 3px;
                max-height: 430px;
                overflow-y: auto;

                .v-list {
                    border-bottom: 1px solid $ypo-tile-border;
                    padding: 0;
                    transition: 0.3s ease all;
                    cursor: pointer;

                    &:last-child {
                        border-bottom: 0;
                    }

                    &:hover {
                        background-color: rgba($ypo-blue, 0.1);
                    }
                }

                .v-list__tile__title {
                    font-weight: bold;
                    color: $ypo-cta;
                }

                .v-list__tile__sub-title {
                    font-weight: 500;
                    color: $ypo-blue !important;
                    font-family: Raleway, serif;
                    font-size: 12px;
                }

                &__spinner {
                    min-height: 80px;
                }

                &__see-all {
                    border-top: 1px solid $ypo-tile-border;

                    .v-list__tile__title {
                        text-align: right;
                    }
                }
            }

        }

        &__sort {
            background-color: $ypo-tile-bgcolor;
            display: flex;
            align-items: center;
            padding: 10px 10px 10px 15px;
            margin: 0 40px;

            .sort_select {
                font-size: 14px;

                .v-input__slot {
                    background-color: transparent !important;
                    border: 0;
                    padding: 0 !important;

                    .v-select__selection {
                        color: $ypo-cta;
                    }

                    .v-icon {
                        color: $ypo-cta;
                    }
                }
            }

            span {
                min-width: 55px;
            }
        }
    }

    .prospective-member {
        &__success_Message {
            color: $ypo-green;
        }

        &__loading {
            padding: 10px 0px 10px 0px;
            font-size: 15px;
        }

        &__list-item {
            border-bottom: 1px solid $ypo-tile-border;
            align-items: center;
            padding: 10px 15px;

            &__view {
                font-weight: bold;

                span {
                    display: block;
                    color: $ypo-gray-text;
                    font-family: Raleway, serif;
                }

                .waiver-date {
                    color: $ypo-gray-text;
                    font-family: Raleway;
                    font-size: 12px;
                }

                i {
                    color: $ypo-cta;
                    cursor: pointer;
                }
            }

            &__actions {
                .status {
                    display: inline-block;
                    text-align: center;
                    width: 50%;
                    color: $ypo-blue;
                    font-weight: 600;

                    em {
                        display: inline-block;
                        font-style: normal;
                        font-weight: 600;
                        color: $ypo-blue;
                        font-size: 18px;
                    }
                }

                .custom-tooltip {
                    &__info {
                        background: $ypo-tile-bgcolor;
                        box-shadow: 0px 1px 6px 2px rgba($black, 0.2);
                        top: auto;
                        bottom: 40px;
                        max-width: 800px;
                        white-space: nowrap;
                        margin: 0 !important;
                        left: auto;
                        right: -20px;
                        padding: 0px !important;
                        min-width: 100px;

                        &:before,
                        &:after {
                            border-top: 17px solid rgba($black, 0.10);
                            border-left: 10px solid transparent;
                            border-right: 10px solid transparent;
                            border-bottom: 0;
                            bottom: -18px;
                            top: auto;
                            left: auto;
                            right: 15px;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            border-top: 15px solid $ypo-tile-bgcolor;
                            bottom: -15px;
                        }

                        .info-list {
                            display: inline-block;
                            margin: 10px;
                            text-align: center;
                            min-width: 80px;

                            img {
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                border: 3px $ypo-tile-border solid;
                            }

                            span {
                                color: $ypo-dark-background-gray;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                                font-size: 12px;
                                font-weight: 500;
                                display: block;
                                max-width: 80px;
                            }
                        }
                    }
                }

            }

            .success-text {
                color: $ypo-green;
            }

            .failure-text {
                color: $ypo-red;
            }

            &__sent-info {
                display: inline-block;
                vertical-align: middle;
                font-size: 12px;

                em {
                    display: block;
                }

                &.check-list {
                    &__error-info {
                        padding-left: 120px;
                        text-align: center;
                    }
                }
            }

            &__save-info {
                display: inline-block;
                font-size: 12px;
                width: 160px;
                color: $ypo-green;
            }

            &__sent-status {
                min-width: 168px;
                display: inline-block;
            }

            .admin-btn {
                min-width: 150px;
                font-size: 12px;
                padding: 10px 0;
            }

            .check-list {
                position: relative;

                &__cont {
                    opacity: 0;
                    background: $ypo-extra-light-gray;
                    box-shadow: 0px 1px 6px 1px rgba($black, 0.2);
                    position: absolute;
                    min-width: 200px;
                    top: -10px;
                    max-width: 200px;
                    border-radius: 3px;
                    padding: 10px;
                    visibility: hidden;
                    z-index: 1;
                    left: 0px;
                    transition: 0.3s all ease-in;
                    margin-left: -200px;

                    &:before,
                    &:after {
                        content: "";
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-top: 11px solid transparent;
                        border-bottom: 11px solid transparent;
                        border-left: 16px solid rgba($black, 0.15);
                        right: -17px;
                        top: 14px;
                    }

                    &:after {
                        border-top: 10px solid transparent;
                        border-bottom: 10px solid transparent;
                        border-left: 15px solid $ypo-extra-light-gray;
                        right: -15px;
                        top: 15px;
                    }

                    .v-input--checkbox {
                        margin-bottom: 5px;
                    }

                    .v-label {
                        font-size: 12px;
                        font-weight: 500;
                        display: block;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }

                    .v-icon {
                        color: $ypo-cta;
                        font-size: 18px;
                    }

                    .v-input__control {
                        width: 100%;
                    }

                    .v-input--selection-controls__input {
                        margin-right: 0;
                    }

                    &__select-all {
                        .v-label {
                            font-style: italic;
                            font-weight: 600;
                            padding-right: 10px;
                        }
                    }
                }

                &:hover {
                    .check-list__cont {
                        opacity: 1;
                        visibility: visible;
                    }

                }
            }

            &__send-back {
                display: inline-flex;
                min-width: 166px;
                padding-left: 25px;
            }

        }

        .view-wavier {
            background-color: rgba($ypo-blue-grey, 0.3);
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba($black, 0.2);
            border: 1px solid rgba($ypo-blue-grey, 0.8);
            opacity: 0;
            overflow: hidden;
            height: 0;
            transition: all 0.5s;

            &.active {
                height: auto;
                opacity: 1;
            }

            h1 {
                text-align: center;
                font-weight: 500;
                font-family: Raleway, serif;
                font-size: 22px;
                padding-left: 0;
                color: $ypo-blue;
                margin-bottom: 12px;

                span {
                    color: $ypo-red;
                }
            }

            h2 {
                padding-left: 0;
                border-bottom: 0;
                margin-bottom: 12px;
            }

            .form-control {
                span {
                    color: $ypo-cta;
                    display: block;
                }

                small {
                    color: $ypo-cta;
                    font-size: 12px;
                }

                em {
                    font-size: 12px;
                }

                .error-color {
                    color: $ypo-error-red;
                    font-weight: bold;
                }

                .char-count {
                    text-align: right;
                    font-size: 12px;
                }
            }

            .attach-documents {
                .card__file-upload {
                    color: $ypo-cta;
                    font-size: 14px;
                    text-align: center;
                    padding: 8px 15px;
                    border: 1px $ypo-cta dashed;
                    font-weight: 500;
                    cursor: pointer;
                    display: inline-block;
                    transition: 0.3s all ease;
                    margin-top: 15px;

                    &:hover {
                        background-color: $ypo-cta;
                        color: $white;
                    }

                    i {
                        margin-right: 10px;
                    }
                }

                .attachment-error {
                    padding-top: 10px;
                    display: inline-block;
                }

                &__file-upload-spinner {
                    margin: 16px 0 0 20px;
                }
            }
        }

    }

    .prospective-member {
        &__status {
            display: inline-block;
            min-width: 160px;
            text-align: center;
        }

        &__list-item {
            &__user {
                .theme--light.v-list {
                    background: transparent;
                }

                .v-list__tile {
                    padding: 0;
                    height: auto;
                }

                .v-list__tile__title {
                    font-weight: bold;
                    color: $ypo-cta;

                    i {
                        color: $ypo-green;
                        padding-left: 10px;
                    }
                }

                .v-list__tile__sub-title {
                    font-weight: 500;
                    color: $ypo-blue !important;
                    font-family: Raleway, serif;
                    font-size: 12px;
                }
            }
        }

        .view-wavier {
            .form-control {
                .v-input {
                    margin-top: 10px;
                }

                .v-input__control {
                    min-height: inherit;
                }

                .v-input__slot {
                    background: transparent !important;
                    box-shadow: none !important;
                    padding-left: 0 !important;
                    padding-right: 0;

                    &:before {
                        border-color: rgba($black, 0.2);
                    }
                }

                input {
                    border-bottom: 1px solid rgba($black, 0.2);
                }

                .v-select__slot {
                    input {
                        border-bottom: 0;
                    }
                }

                .v-label,
                input {
                    font-size: 14px;
                    font-weight: bold;
                    color: $ypo-gray-text !important;
                }

                .v-textarea {
                    .v-input__slot {
                        border: 1px solid rgba($black, 0.2);
                        padding-left: 10px !important;
                        border-radius: 4px;
                    }
                }

                &.link {

                    .v-label,
                    input {
                        color: $ypo-cta !important;
                    }
                }

                .v-menu__content {
                    box-shadow: 0 2px 5px 0 rgba($black, 0.18);
                    border: 1.5px solid rgba($ypo-text-border, 0.25);
                    border-radius: 3px;

                    .v-list {
                        background: $ypo-extra-light-gray;

                        &>div {
                            &:hover {
                                background: $ypo-cta;

                                .v-list__tile__title {
                                    color: $white;
                                }
                            }

                            .v-list__tile__title {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
        }
    }

    .waiver-block {
        @include breakpoint(sm) {
            .prospective-member {
                &__list-item {
                    &__sent-info {
                        &.check-list {
                            &__error-info {
                                padding-left: inherit;
                                text-align: inherit;
                            }
                        }
                    }
                }
            }
        }

        @include breakpoint(xs) {
            margin: 15px 10px !important;
            padding-bottom: 50px;

            .prospective-member {
                &__list-item {
                    border: 1px solid $ypo-tile-border;
                    margin: 10px;
                    border-radius: 3px;
                    background: rgba($ypo-tile-border, 0.15);

                    &__view {
                        border-top: 1px dashed $ypo-medium-gray;
                        border-bottom: 1px dashed $ypo-medium-gray;
                        padding: 10px 0 10px 56px;
                        margin: 5px 0;
                        display: inherit;

                        i {
                            margin-top: 2px;
                            font-size: 14px;
                            padding: 0px 10px;
                        }

                        span {
                            font-size: 12px;
                            flex: initial;
                            display: inherit;
                        }

                        .waiver-date {
                            margin-right: 15px;
                        }
                    }

                    &__sent-info,
                    &__status {
                        padding-left: 56px;
                    }

                    &__actions {
                        padding: 5px 0px 5px 56px;
                        border-bottom: 1px dashed $ypo-medium-gray;
                        margin-bottom: 5px;

                        .custom-tooltip__info {
                            max-width: inherit;

                            &__details {
                                max-width: 260px;
                                overflow: auto;
                            }

                        }

                        .deny {
                            .custom-tooltip__info {
                                right: inherit;
                                left: -20px;

                                &:before,
                                &:after {
                                    left: 15px;
                                    right: inherit;
                                }

                                &:after {
                                    left: 9px;
                                }
                            }
                        }

                        .status {
                            width: auto;
                            margin-right: 20px;
                        }
                    }

                    &__send-back {
                        min-width: inherit;
                    }

                    &__btns {
                        padding-left: 30px;

                        p {
                            padding-left: 25px;
                            margin-bottom: 0px;
                        }
                    }

                    &__comment_btn {
                        padding-left: 50px;
                    }

                    .check-list__cont {
                        left: 0;
                        margin-left: 0;
                        top: 35px;

                        &:before,
                        &:after {
                            display: none;
                        }
                    }
                }

                .view-wavier {
                    &__block {
                        padding: 10px !important;

                        h1,
                        h2 {
                            font-size: 16px;
                            line-height: normal;
                        }
                    }
                }

                &-header {
                    &__sort {
                        margin: 0px 15px;

                        &__block {
                            padding-right: 0px !important;
                        }
                    }

                    &__prospect {
                        margin: 5px 15px;
                    }
                }

                .check-list {
                    &__error-info {
                        padding-left: 0;
                        position: absolute;
                        right: -120px;
                        top: -5px;
                        max-width: 130px;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>
